// import React, { useState } from "react";
// import Lightbox from "yet-another-react-lightbox";
// import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
// import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
// import "yet-another-react-lightbox/styles.css";
// import galleryimages from "../components/galleryimages";

// export default function GalleryImage({ images = [], startIndex = 0 }) {
//   const [open, setOpen] = useState(false);
//   const [index, setIndex] = useState(startIndex);

//   const handleOpen = (i) => {
//     setIndex(i);
//     setOpen(true);
//   };
// //   const exteriorImages = [
// //   { src: "/public/Gallerypics/76608295b5e9c1f4bc3b6951da090bff.jpg", caption: "Building Exterior" },
// //   { src: "/Gallerypics/image2.jpg", caption: "Factory Painting" },
// //   // more images
// // ];


//   return (
//     <>
//       <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
//         {images.map((img, i) => (
//           <div key={i} style={{ textAlign: 'center', maxWidth: 240 }}>
//             <img
//               src={img.src}
//               alt={img.alt || `Gallery image ${i + 1}`}
//               onClick={() => handleOpen(i)}
//               style={{ width: '100%', height: 150, objectFit: 'cover', borderRadius: 12, cursor: "pointer", boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
//             />
//             {img.caption && <p style={{ fontSize: '14px', marginTop: '8px', color: '#555' }}>{img.caption}</p>}
//           </div>
//         ))}
//       </div>
//       <GalleryImage images={exteriorImages} />

//       <Lightbox
//         open={open}
//         close={() => setOpen(false)}
//         index={index}
//         slides={images.map((img) => ({ src: img.src, title: img.caption }))}
//         plugins={[Fullscreen, Slideshow]}
//       />
//     </>
//   );
// }

import GalleryImage from "../components/galleryimages";

const images = [
  {src: '/Project pics/Work7.JPG',caption: "Factory Painting"},
  { src: "/Project pics/Work8 (1).jpg", caption: "Building Exterior" },
  { src: "/Project pics/Work8 (6).jpg", caption: "Tennis Court Project" },
   { src: "/Project pics/Al Makkah.jpg", caption: "Factory Painting" },
  {src:'/Project pics/Work8 (2).jpg', caption: "Factory Painting"},
  { src: '/Project pics/Work1.JPG',caption: "Factory Painting"},
  { src:'/Project pics/Work2.JPG',caption: "Factory Painting"},
   {src: '/Project pics/interior 2.JPG',caption: "Factory Painting"},
   {src: '/Project pics/Work4.JPG',caption: "Factory Painting"},
   {src:   '/Project pics/Velvet Touch Wall.jpg',caption: "Velvet Touch"},
   {src:   '/Project pics/Work6.JPG',caption: "Factory Painting"},
   {src:   '/Project pics/Work8 (7).jpg',caption: "Factory Painting"},
   {src:   '/Project pics/Work5.JPG',caption: "Factory Painting"},
   {src:   '/Project pics/Work8 (5).jpg',caption: "Factory Painting"},
   {src:   '/Project pics/Teniss FAsial.jpg',caption: "Factory Painting"},
   {src:   '/Project pics/Tennis 3(1).JPG',caption: "Factory Painting"},
   {src:   '/Project pics/Khyaban.JPG',caption: "Factory Painting"},
   {src:   '/Project pics/Tennis1.JPG',caption: "Tennis Court Painting"},
   {src:   '/Project pics/Superior Building.jpg',caption: "Superior College Fsd"},
   {src:   '/Project pics/Work8 (8).jpg',caption: "Factory Painting"},
   {src:   '/Project pics/Tennis 3.JPG',caption: "Factory Painting"},
   {src:   '/Project pics/Work9 (2).jpg',caption: "Factory Painting"},
   {src:   '/Project pics/interior1.JPG',caption: "Factory Painting"},
   {src:   '/Project pics/Work9 (1).jpg',caption: "Factory Painting"},
   {src:   '/Project pics/Work9 (2).jpg',caption: "Factory Painting"},
   {src:   '/Project pics/Tennis 2.jpg',caption: "Factory Painting"},
   {src:   '/Project pics/Chenab Club .jpg',caption: "Chenab Club Painting"},
  
   {src:   '/Project pics/Lining floor.JPG',caption: "Factory Lining Painting"},
   {src:   '/Project pics/Work9 (6).jpg',caption: "Factory Painting"},
   {src:   '/Project pics/Chenab Club .jpg',caption: "Factory Painting"},
   {src:   '/Project pics/marquee1.jpg',caption: "Factory Painting"},
   {src:   '/Project pics/marquee2.jpg',caption: "Factory Painting"},
   {src:   '/Project pics/stunder.jpg',caption: "Factory Painting"},
   {src:   '/Project pics/ceiling.jpg',caption: "Factory Painting"},


  // Add more images here
];

export default function GallerySection() {
  return (
    <section id="gallery" style={{ padding: '120px 0' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '30px', color:"#008080"}}>Project Gallery</h2>
      <GalleryImage images={images} />
    </section>
  );
}




// const Gallery = () => 
//  {
//     return(<section id="gallery">
//         <h1>Gallery</h1>
//         </section>);}

// export default Gallery;

// const images = [
//     'https://source.unsplash.com/800x600/?paint,building',
//     'https://source.unsplash.com/800x600/?industrial,painting',
//     'https://source.unsplash.com/800x600/?tennis,court',
//     'https://source.unsplash.com/800x600/?factory,interior',
//     'https://source.unsplash.com/800x600/?home,painting',
//     'https://source.unsplash.com/800x600/?wall,coating'
// ];
  
  
//   const Gallery = () => {
//     return (
//       <section id="gallery" style={{ padding: '80px 20px', backgroundColor: '#fff' }}>
//         <h2 data-aos="fade-up" style={{ textAlign: 'center', marginBottom: '40px' }}>
//           Our Work Gallery
//         </h2>
//         <div
//           className="gallery-grid"
//           style={{
//             display: 'grid',
//             gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//             gap: '15px',
//             maxWidth: '1100px',
//             margin: '0 auto'
//           }}
//         >
//           {images.map((src, index) => (
//             <img
//               data-aos="zoom-in"
//               key={index}
//               src={src}
//               alt={`Gallery ${index + 1}`}
//               style={{
//                 width: '100%',
//                 height: '200px',
//                 objectFit: 'cover',
//                 borderRadius: '10px',
//                 boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//                 cursor: 'pointer'
//               }}
//             />
//           ))}
//         </div>
//       </section>
//     );
//   };
  
//   export default Gallery;


// import { useState } from 'react';
// // import 'react-image-lightbox/style.css';
// // import "yet-another-react-lightbox/styles.css";
// import Lightbox from "yet-another-react-lightbox";
// import "yet-another-react-lightbox/styles.css";
// // import Lightbox from 'react-image-lightbox';
// // import Samplepic from '../Gallerypics/4K Wallpapers 1 (217).jpg'

// const images = [
//   '/Gallerypics/construction-worker-painting-fence-home.jpg',
//   '/Gallerypics/tennis-court-render-3d-illustration.jpg',
//   '/Gallerypics/oleksii-s-O2kqxbix4Mw-unsplash.jpg',
//   '/Gallerypics/jose-antonio-gallego-vazquez-sOjnl87-HrU-unsplash.jpg',
//   'https://images.unsplash.com/photo-1540574163026-643ea20ade25?auto=format&fit=crop&w=800&q=80',
//   '/Gallerypics/tolu-olarewaju-j1lLzoi7o1o-unsplash.jpg',
//   '/Gallerypics/4K Wallpapers 1 (217).jpg',
//   '/Gallerypics/ali-mkumbwa-1iho4gvI4-g-unsplash.jpg',
// ];


// const Gallery = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [photoIndex, setPhotoIndex] = useState(0);

//   return (
//     <section id="gallery" style={{ padding: '80px 20px', backgroundColor: '#fff' ,marginTop:"45px"}}>
//       <h2 data-aos="fade-up" style={{ textAlign: 'center', marginBottom: '40px' }}>
//         Our Work Gallery
//       </h2>
//       <div
//         className="gallery-grid"
//         style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//           gap: '15px',
//           maxWidth: '1100px',
//           margin: '0 auto'
//         }}
//       >
//         {images.map((src, index) => (
//           <img
//             key={index}
//             src={src}
//             alt={`Gallery ${index + 1}`}
//             onClick={() => {
//               setPhotoIndex(index);
//               setIsOpen(true);
//             }}
//             style={{
//               width: '100%',
//               height: '200px',
//               objectFit: 'cover',
//               borderRadius: '10px',
//               boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//               cursor: 'zoom-in'
//             }}
//             data-aos="zoom-in"
//           />
          
          
//         ))}
//       </div>

//        {isOpen && (
//         <Lightbox
//           mainSrc={images[photoIndex]}
//           nextSrc={images[(photoIndex + 1) % images.length]}
//           prevSrc={images[(photoIndex + images.length - 1) % images.length]}
//           onCloseRequest={() => setIsOpen(false)}
//           onMovePrevRequest={() =>
//             setPhotoIndex((photoIndex + images.length - 1) % images.length)
//           }
//           onMoveNextRequest={() =>
//             setPhotoIndex((photoIndex + 1) % images.length)
//           }
//         />
//       )}
//     </section> 
//   );
// };

// export default Gallery;

  


// import React, { useState } from "react";
// import Lightbox from "yet-another-react-lightbox";
// import "yet-another-react-lightbox/styles.css";

// export default function GalleryImage({ images, startIndex = 0 }) {
//   const [open, setOpen] = useState(false);
//   const [index, setIndex] = useState(startIndex);

//   const handleOpen = (i) => {
//     setIndex(i);
//     setOpen(true);
//   };


//   return (
//     <>
//       <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'center' }}>
//         {images.map((img, i) => (
//           <div key={i} style={{ textAlign: 'center' }}>
//             <img
//               src={img.src}
//               alt={img.alt || `Gallery image ${i + 1}`}
//               onClick={() => handleOpen(i)}
//               style={{ width: 220, height: 140, objectFit: 'cover', borderRadius: 10, cursor: "pointer" }}
//             />
//             {img.caption && <p style={{ fontSize: '14px', marginTop: '5px', color: '#555' }}>{img.caption}</p>}
//           </div>
//         ))}
//       </div>

//       <Lightbox
//         open={open}
//         close={() => setOpen(false)}
//         index={index}
//         slides={images}
//       />
//     </>
//   );
// }
